export default "__VITE_ASSET__CkZt1sIW__"